/* eslint-disable react/button-has-type */
import React from 'react';

const IconError = () => {
  return (
    <svg width="197px" height="149px" viewBox="0 0 197 149" xmlns="http://www.w3.org/2000/svg">
      <g id="0-Common-Elements" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="error-incorrect-url" transform="translate(-734.000000, -224.000000)">
          <g id="Icons_payment-error-copy-1" transform="translate(734.000000, 224.000000)">
            <path
              d="M108,122.751644 C86.3607762,127.699395 64.0858665,117.630672 53.3021009,98.0270534 C42.5183353,78.4234351 45.8075001,53.9783062 61.3789195,38"
              id="Path"
              stroke="#00B9F2"
            />
            <path
              d="M95,23 L97.3281521,23 C116.683336,22.9870819 134.352866,33.9053455 142.85395,51.1310743 C151.355033,68.3568032 149.200407,88.8763572 137.302523,104"
              id="Path"
              stroke="#00B9F2"
            />
            <g
              id="Group"
              opacity="0.2"
              transform="translate(36.000000, 43.000000)"
              stroke="#58595B"
            >
              <path
                d="M100.556444,76.2142857 C78.2424055,95.2491886 45.4640726,95.4956041 22.865987,76.7983342 C0.267901385,58.1010642 -5.60591555,25.8745202 8.944,0.415714286"
                id="Path"
                fill="#FFFFFF"
              />
              <polyline
                id="Path"
                points="79.6871111 72.2188095 102.081778 75.0364286 99.3777778 96.607381"
              />
            </g>
            <g id="Group" opacity="0.2" transform="translate(59.000000, 4.000000)" stroke="#58595B">
              <path
                d="M2.04651163,20.2939024 C24.1527848,3.71385072 54.709769,4.10653997 76.3794821,21.249159 C98.0491951,38.3917779 105.359602,67.9554734 94.1627907,93.1658537"
                id="Path"
                fill="#FFFFFF"
              />
              <polyline
                id="Path"
                points="23.0465116 25.7390244 0.627906977 21.9853659 4.25581395 0.482926829"
              />
            </g>
            <g id="Group" opacity="0.2" transform="translate(0.000000, 66.000000)" stroke="#D3CFD0">
              <line x1="18.88" y1="10.08" x2="0.0733333333" y2="10.08" id="Path" />
              <line x1="9.47666667" y1="0.676666667" x2="9.47666667" y2="19.4833333" id="Path" />
            </g>
            <g
              id="Group"
              opacity="0.2"
              transform="translate(138.000000, 0.000000)"
              stroke="#A39D9F"
            >
              <line x1="15.0857143" y1="7.6625" x2="0" y2="7.6625" id="Path" />
              <line x1="7.54285714" y1="0.215" x2="7.54285714" y2="15.0875" id="Path" />
            </g>
            <g
              id="Group"
              opacity="0.2"
              transform="translate(175.000000, 127.000000)"
              stroke="#D3CFD0"
            >
              <line x1="11.086" y1="0.587" x2="11.086" y2="21.701" id="Path" />
              <line x1="0.552" y1="11.144" x2="21.643" y2="11.144" id="Path" />
            </g>
            <path
              d="M109,82 C101.339236,76.6666667 90.6607637,76.6666667 83,82"
              id="Path"
              stroke="#0091D0"
            />
            <circle id="Oval" fill="#0091D0" cx="119" cy="66" r="3" />
            <circle id="Oval" fill="#0091D0" cx="73" cy="66" r="3" />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default IconError;
